'use strict';

const cardTotals = {
    elements: {
        $cartWrapper: $('.js-cart')
    },

    state: {
    },

    selectors: {
        squirrellyId: '#cartTotals',
        cardTotalsWrapper: '.js-cart-totals',
    },

    renderCartTotals(cart) {
        $(this.selectors.cardTotalsWrapper).morphBy({
            id: this.selectors.squirrellyId,
            squirrellyOptions: {
                totals: cart.totals,
            },
            morphDomOptions: { morph: true, childrenOnly: true }
        });
    },
};

module.exports = {
    renderCartTotals: (cart) => cardTotals.renderCartTotals(cart)
};